import { NewTag, Tag } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

export const tagConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): Tag => {
    const data = snapshot.data() as Record<string, unknown>;
    return {
      ...data,
      name:
        typeof data.name === 'string'
          ? (data.name as string).trim()
          : data.name,
      createdAt: firebaseTimestampToDate(data.createdAt as Date),
      updatedAt: data.updatedAt
        ? firebaseTimestampToDate(data.updatedAt as Date)
        : undefined,
    } as Tag;
  },
  toFirestore: (tag: Tag) => tag,
};

export const newTagConverter = (tag: NewTag) => ({
  ...tag,
  createdAt: new Date(),
});
